import { Box, Collapse, IconButton, Paper, Table, TableBody, TableContainer, TableCell, TableHead, TableRow, TextField, Typography, useTheme, ListItemButton, Menu, MenuItem, TablePagination, TableSortLabel, Skeleton, InputAdornment, Theme, useMediaQuery, Tabs, Tab } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import CustomDropdown from '../../../lib/formik/CustomDropdown'
import { ActionIcon, DialogCloseIcon, DropDownIcons, ExportIcon, SearchIcon, SideDropDownIcon } from '../../../assets/SvgIcons'
import IconCustomeDropDown from '../../../lib/formik/IconsCustomeDropDown';
import { useHistory } from 'react-router';
import { off } from 'process';
import { formatCurrency, maskInfo, toINR } from '../../../utils/utilityFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { setClientCode } from '../../../redux-store/actions/investorProfile';
import _ from 'lodash';
import { storeSelectedPortfolio } from '../../../redux-store/actions/portfolioFilter';
import { getAccountsExportData } from '../../../redux-store/actions/userManagement';
import { reportDownload } from '../../Reports/report-utils';
import { useSnackbar } from 'notistack';
import { RootStateType } from '../../../redux-store/reducers';
import { NO_DATA_AVAILABLE } from '../../../utils/constant';
import { useRoleStack } from '../../../hooks/useRoleStack';

// const TableCell = styled(MuiTableCell)({
//     width: '50px',
//     // background: 'red'
// })


const filter = [
    {
        "label": "By Individual",
        "value": 1
    },
    {
        "label": "By Family",
        "value": 2
    }
]

interface AccountProps {
    isLoading: boolean
    accountTable: {
        individual: Array<RowProps>,
        family: Array<RowProps>
    },
    aumAmount: number,
    error: boolean,
    exportData: any;
    investorAccountOptions: Array<{ label: string, value: string }>;
    invAccountTab: string;
    handleOuterTabChange: any
}

export interface RowProps {
    familyName?: string,
    familyId?: string,
    customerName?: string,
    portfolioName?: string,
    name?: string,
    // portfolioName: string,
    child?: boolean,
    list?: Array<RowProps>,
    ofBook?: number,
    investedValue?: number,
    marketValue?: number,
    unrealised?: number,
    unrealisedPercentage?: number,
    cash?: number,
    irr?: number,
    id?: number,
    clickable?: boolean,
    family?: boolean,
    clientCode?: string,
    portfoiloId?: string,
    familyCode?: string,
    familyHead?: string,
    isPortfolioHeldaway?: boolean,
    accountType?: string,
    relationManagerName?: string
}

interface Sorting { name: string, order: "asc" | "desc" | undefined }


export default function Account(props: AccountProps) {
    const { isLoading, accountTable, aumAmount, error, exportData, investorAccountOptions, invAccountTab, handleOuterTabChange } = props
    const { palette } = useTheme()
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory()
    const state = history.location.state as { accountFilter?: number }
    const isMobile = useMediaQuery((theme: Theme) => (theme as Theme).breakpoints.down('sm'))


    const [filterValue, setFilterValue] = useState<number | string>(state?.accountFilter || filter[0].value)
    const [tableData, setTableData] = useState<any[]>([])
    const [rowOption, setRowOption] = useState<number>(5)
    const [rowArray, setRowArray] = useState<number[]>([])
    const [currentPage, setCurrentPage] = useState<number>(0)
    const [searchInput, setSearchInput] = useState<string>('');
    const [exportLoad, setExportLoad] = useState<boolean>(false);
    const [sorting, setSorting] = useState<Sorting>({
        name: '',
        order: 'asc',
    })
    const [mobileOpenMap, setMobileOpenMap] = useState<Record<string, boolean>>({})
    const dispatch = useDispatch();
    const style: any = { color: palette.text.secondary, fontWeight: 500, fontSize: '14px', textTransform: 'uppercase', textWrap: 'nowrap', paddingRight: 0, paddingLeft: 0 }
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    useEffect(() => {
        const dummy = tableData?.length <= 5 ? [5] : tableData?.length <= 10 ? [5, 10] : tableData?.length <= 15 ? [5, 10, 15] : [5, 10, 15, 20]
        setRowArray(dummy)
    }, [tableData])


    useEffect(() => {
        const dummy = [...((filterValue === 1 ? accountTable?.individual : accountTable?.family) || [])]
        setTableData(dummy)
    }, [filterValue, accountTable])


    const handlePageChange = (event: any, page: number) => {
        setCurrentPage(page);
    }

    const handleRow = (row: string | number) => {
        setRowOption(parseInt(row as string))
        setCurrentPage(0)
        setSearchInput('')
    }

    const handleSorting = (name: string) => {
        setCurrentPage(0)

        setSorting((preSorting) => {
            const preNameSort = preSorting.name === name;

            return { name: name, order: preNameSort ? (preSorting.order === 'asc' ? 'desc' : 'asc') : preSorting.order }
        })
    }

    const handleSearch = (value: string) => {
        setCurrentPage(0)
        setRowOption(5)
        setSearchInput(value)
    }

    const handleCancelSearch = () => {
        setCurrentPage(0)
        setRowOption(5)
        setSearchInput('')
    }

    const handleExport = async () => {
        setExportLoad(true)
        try {
            const formatExportedData = [
                {
                    "navDate": "NAV DATE",
                    "familyName": "FAMILY NAME",
                    "customer": "CUSTOMER",
                    "customerName": "CUSTOMER NAME",
                    "activationDate": "ACTIVATION DATE",
                    "portfolio": "PORTFOLIO",
                    "portfolioName": "PORTFOLIO NAME",
                    "startDate": "START DATE",
                    "netAssets": "NET ASSETS",
                    "capital": "CAPITAL",
                    "cashBalance": "CASH BALANCE",
                    "cashflow": "CASH FLOW",
                    "unrelGainLoss": "UNREALISED GAIN LOSS",
                    "return": "RETURN",
                    "WtAvgDays": "WT. AVG DAYS",
                    "isPfInvestExists": "IS PF INVEST EXISTS",
                },
                ...exportData
            ]
            const exportRes = (await dispatch(getAccountsExportData({ jsonData: formatExportedData, sheetName: 'AUM Distribution' }))) as unknown as any;
            reportDownload(exportRes as unknown as Blob, 'AUM Distribution.xlsx');
            enqueueSnackbar('File downloaded successfully.', {
                variant: 'success',
                autoHideDuration: 2000,
            });

        } catch (err) {
            console.log('err', err)
            enqueueSnackbar('File download failed!.', {
                variant: 'error',
                autoHideDuration: 2000,
            });
        }
        setExportLoad(false)
    }

    const { getCurrentStack } = useRoleStack();
    const stack = getCurrentStack();
    const { subRole = "", } = useSelector((store: RootStateType) => store.auth);
    const curRole = stack.length > 0 ? stack[stack.length - 1].role : subRole;

    return (
        <>
            <Box component={'section'} style={{
                width: '100%',
                padding: '25px 15px',
                borderRadius: 20,
                background: '#ffffff',
                boxShadow: `0px 4px 10px 0px ${palette.background.default}`,
                marginTop: '15px'
            }}>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', alignItems: 'center', flexWrap: { lg: 'nowrap', md: 'nowrap', sm: 'wrap', xs: 'wrap' }, rowGap: '20px' }}>
                    <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', gap: '25px', alignItems: 'center', justifyContent: { lg: 'flex-start', md: 'flex-start', sm: 'space-between', xs: 'space-between' }, width: '100%' }}>
                        <Typography variant='h2' sx={{
                            fontWeight: 600,
                            fontSize: 20,
                            color: palette.text.primary
                        }}>
                            Investor Accounts
                        </Typography>
                        <CustomDropdown IsLoading={isLoading} options={filter} defaultValue={state?.accountFilter || filter[0].value} setFilterValue={setFilterValue} />
                    </Box>
                    <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', gap: '25px', alignItems: 'center', justifyContent: { lg: 'flex-end', md: 'flex-end', sm: 'space-between', xs: 'space-between' }, width: '100%' }}>
                        {filterValue === 1
                            &&
                            (
                                <IconButton
                                    aria-label="Export data"
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        gap: '5px',
                                        alignItems: 'center',
                                        padding: '2px 0px',
                                        cursor: 'pointer',
                                        "&:hover": { backgroundColor: "transparent" }

                                    }}
                                    disableFocusRipple={true}
                                    onClick={exportLoad ? () => null : () => handleExport()}
                                >
                                    <ExportIcon />
                                    <Typography
                                        sx={(theme: Theme) => ({
                                            ...theme.typography.body_400,
                                            fontFamily: theme.typography.fontFamily,
                                        })}
                                    >
                                        Export
                                    </Typography>
                                </IconButton>
                            )
                        }
                        <Box>
                            <TextField
                                // autoFocus
                                fullWidth
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="Clear search"
                                                sx={{
                                                    display: searchInput.length > 0 ? 'inline-flex' : 'none',
                                                }}
                                                onClick={handleCancelSearch}
                                            >
                                                <DialogCloseIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                    sx: (theme: Theme) => ({
                                        borderRadius: '57px',
                                        height: '47.17px',
                                        border: `1px solid ${theme.palette.text.secondary}B2`,
                                        // marginTop: '20px',
                                        width: '100%',
                                        maxWidth: '204px',
                                        '& fieldset': {
                                            border: 'none',
                                        },
                                        '& input': {
                                            paddingLeft: '10px',
                                            ...theme.typography.body_500,
                                            color: theme.palette.text.primary,
                                            '::placeholder': {
                                                ...theme.typography.subtitle_400,
                                                color: theme.palette.text.secondary,
                                                opacity: 1,
                                            },
                                        },
                                    }),
                                }}
                                placeholder="Search"
                                value={searchInput}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    handleSearch(event.target.value);
                                }}
                            />

                        </Box>
                    </Box>
                </Box>

                {/* Tabs */}

                {(!["IFA", "BRANCH"].includes(curRole)) && (
                    <>
                        <Box sx={{ mt: 2, width: '30%' }}>
                            <Tabs
                                value={invAccountTab}
                                onChange={handleOuterTabChange}
                                variant="fullWidth"
                                aria-label="Investor account type"
                                sx={{
                                    minHeight: '35px',
                                    '& .MuiTabs-indicator': {
                                        display: 'none',
                                    },
                                    '& .MuiTab-root': {
                                        minHeight: '32px',
                                        padding: '5px 10px',
                                        minWidth: 'auto',
                                    }
                                }}
                            >
                                {investorAccountOptions.map((obj, index) => (
                                    <Tab
                                        value={obj.value}
                                        aria-label={obj.label}
                                        disabled={invAccountTab !== obj.value && isLoading}
                                        key={index}
                                        label={
                                            <Typography
                                                aria-hidden="true"
                                                variant='body_500'
                                                sx={(theme: Theme) => ({
                                                    color: invAccountTab === obj.value ? theme.palette.textDark.primary : theme.palette.text.secondary,
                                                    textTransform: 'capitalize'
                                                })}
                                            >
                                                {obj.label}
                                            </Typography>
                                        }
                                        sx={(theme: Theme) => ({
                                            minHeight: '35px',
                                            padding: '5px 8px',
                                            minWidth: 'auto',
                                            backgroundColor:
                                                invAccountTab === obj.value
                                                    ? theme.palette.primary[500]
                                                    : theme.palette.common.white,
                                            borderRadius: "12px",
                                            '&.Mui-disabled': {
                                                backgroundColor: theme.palette.grey[50],
                                                color: theme.palette.grey[500],
                                                cursor: 'not-allowed',
                                                opacity: 0.8,
                                            },
                                        })}
                                    />
                                ))}
                            </Tabs>
                        </Box>

                        <hr aria-hidden="true" />
                    </>
                )}

                {/* Mobile boxed view */}
                <Box sx={{ display: { xs: 'block', sm: 'none' }, padding: '15px 0px' }}>
                    {isLoading ? <TableLoader row={5} column={1} /> : null}
                    {!isLoading && error ? (
                        <Typography sx={{ textAlign: 'center' }} variant='h2' color={'text.primary'}>{NO_DATA_AVAILABLE}</Typography>
                    ) : (
                        <>
                            {(_.orderBy(tableData, [sorting.name], [sorting.order ? sorting.order : 'desc'])
                                .filter((row) => filterValue === 1 ? row.customerName?.toLowerCase().includes(searchInput?.toLowerCase()) : row.familyName?.toLowerCase().includes(searchInput?.toLowerCase()))
                                .sort((a, b) => sorting.order === 'desc' ? (a[sorting.name] - b[sorting.name]) : (b[sorting.name] - a[sorting.name]))
                                .slice((currentPage) * rowOption, ((currentPage) * rowOption) + rowOption))
                                .map((row, i) => (
                                    <Paper key={i + (row?.portfolioName || '')} elevation={0} sx={{
                                        border: `1px solid ${palette.text.secondary}4D`,
                                        borderRadius: '12px',
                                        padding: '12px 12px',
                                        marginBottom: '12px',
                                    }}>
                                        <Box>
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                                                    {row?.child ? (
                                                        <IconButton
                                                            aria-label="expand card"
                                                            size="small"
                                                            sx={{ p: '2px' }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                const keyId = `${i}-${row?.portfolioName || row?.clientCode || row?.familyName || ''}`;
                                                                setMobileOpenMap((prev) => ({ ...prev, [keyId]: !prev[keyId] }))
                                                            }}
                                                        >
                                                            {mobileOpenMap[`${i}-${row?.portfolioName || row?.clientCode || row?.familyName || ''}`] ? <DropDownIcons /> : <SideDropDownIcon />}
                                                        </IconButton>
                                                    ) : (
                                                        <IconButton size="small" aria-hidden="true" style={{ backgroundColor: 'transparent', visibility: 'hidden' }} disableRipple>
                                                            <SideDropDownIcon />
                                                        </IconButton>
                                                    )}
                                                    <Typography
                                                        variant='h2'
                                                        onClick={() => {
                                                            if (filterValue === 2 && (row?.familyName?.toLowerCase?.() === 'not applicable')) {
                                                                return;
                                                            }
                                                            dispatch(setClientCode((row?.clientCode || "") as string))
                                                            dispatch(storeSelectedPortfolio({ label: '', value: '' }))
                                                            if (filterValue === 1) {
                                                                history.push(`/investor-profile/${row?.customerName}`, {
                                                                    clientCode: (row?.clientCode || "") as string,
                                                                    portfoiloId: row?.portfoiloId || "",
                                                                    accountFilter: filterValue
                                                                })
                                                            } else if (filterValue === 2) {
                                                                history.push(`/family-profile/${(maskInfo(row?.familyName || ""))}`, {
                                                                    familyName: (row?.familyName || "") as string,
                                                                    accountFilter: filterValue,
                                                                    relationManager: (row?.relationManager || "") as string
                                                                })
                                                            }
                                                        }}
                                                        sx={{
                                                            fontWeight: 600,
                                                            fontSize: 16,
                                                            color: palette.primary[500],
                                                            textTransform: 'capitalize',
                                                            cursor: (filterValue === 2 && (row?.familyName?.toLowerCase?.() === 'not applicable')) ? 'default' : 'pointer',
                                                            opacity: (filterValue === 2 && (row?.familyName?.toLowerCase?.() === 'not applicable')) ? 0.5 : 1
                                                        }}
                                                    >
                                                        {filterValue === 1
                                                            ? row?.customerName?.toLowerCase()
                                                            : (row?.familyName === 'Not Applicable' ? row?.customerName?.toLowerCase() : maskInfo((row?.familyName || '')?.toLowerCase()))}
                                                        {`${(row?.list?.length ?? 0) > 0 ? ` (${row?.list?.length})` : ''}`}
                                                    </Typography>
                                                </Box>
                                                <Box onClick={(e) => e.stopPropagation()}>
                                                    <IconCustomeDropDown data={row} filterValue={filterValue as any} isToggle={!row?.child} />
                                                </Box>
                                            </Box>
                                            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginTop: '10px' }}>
                                                <Box>
                                                    <Typography sx={{ color: palette.text.secondary, fontSize: 11, textTransform: 'uppercase' }}>% of book</Typography>
                                                    <Typography sx={{ color: palette.text.primary, fontWeight: 500, fontSize: 10 }}>{row?.marketValue ? ((((row?.marketValue as number) / aumAmount) * 100) || 0)?.toFixed(2) : 0}</Typography>
                                                </Box>
                                                <Box>
                                                    <Typography sx={{ color: palette.text.secondary, fontSize: 11, textTransform: 'uppercase', textAlign: 'right' }}>invested value</Typography>
                                                    <Typography sx={{ color: palette.text.primary, fontWeight: 500, fontSize: 10, textAlign: 'right' }}>{row?.investedValue as number < 0 ? `- ${formatCurrency({ value: Math.abs(row?.investedValue ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: row?.investedValue ?? 0, locale, currencyCode })}`}</Typography>
                                                </Box>
                                                <Box>
                                                    <Typography sx={{ color: palette.text.secondary, fontSize: 11, textTransform: 'uppercase' }}>market value</Typography>
                                                    <Typography sx={{ color: palette.text.primary, fontWeight: 500, fontSize: 10 }}>{row?.marketValue as number < 0 ? `- ${formatCurrency({ value: Math.abs(row?.marketValue ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: (row?.marketValue ?? 0), locale, currencyCode })}`}</Typography>
                                                </Box>
                                                <Box>
                                                    <Typography sx={{ color: palette.text.secondary, fontSize: 11, textTransform: 'uppercase', textAlign: 'right' }}>unrealised return</Typography>
                                                    <Typography sx={{ color: (row?.unrealised as number) < 0 ? palette.error[500] : palette.success[500], fontWeight: 500, fontSize: 10, textAlign: 'right' }}>{row?.unrealised as number >= 0 ? '' : '-'}{formatCurrency({ value: Math.abs(row?.unrealised as number), locale, currencyCode })}</Typography>
                                                </Box>
                                                <Box>
                                                    <Typography sx={{ color: palette.text.secondary, fontSize: 11, textTransform: 'uppercase' }}>cash available</Typography>
                                                    <Typography sx={{ color: palette.text.primary, fontWeight: 500, fontSize: 10 }}>{row?.cash as number < 0 ? `- ${formatCurrency({ value: Math.abs(row?.cash ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: row?.cash ?? 0, locale, currencyCode })}`}</Typography>
                                                </Box>
                                                <Box>
                                                    <Typography sx={{ color: palette.text.secondary, fontSize: 11, textTransform: 'uppercase', textAlign: 'right' }}>Absolute Return %</Typography>
                                                    <Typography sx={{ color: (row?.irr as number) < 0 ? palette.error[500] : palette.success[500], fontWeight: 500, fontSize: 10, textAlign: 'right' }}>{row?.irr?.toFixed(2)}%</Typography>
                                                </Box>
                                            </Box>
                                            {(row?.child && mobileOpenMap[`${i}-${row?.portfolioName || row?.clientCode || row?.familyName || ''}`]) && (
                                                <Box sx={{ mt: 1 }}>
                                                    {row?.list?.map((item: RowProps, ci: number) => (
                                                        <Paper key={`c-${ci}`} elevation={0} sx={{ border: `1px dashed ${palette.text.secondary}4D`, borderRadius: '10px', padding: '10px', mb: '8px' }}>
                                                            <Box onClick={() => {
                                                                dispatch(setClientCode((item?.clientCode || "") as string))
                                                                dispatch(storeSelectedPortfolio({ label: '', value: '' }))
                                                                history.push(`/investor-profile/${item?.customerName}`, {
                                                                    clientCode: (item?.clientCode || "") as string,
                                                                    portfoiloId: item?.portfoiloId || "",
                                                                    accountFilter: filterValue
                                                                })
                                                            }} sx={{ cursor: 'pointer' }}>
                                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                                                                    <Typography sx={{ color: palette.primary[500], fontWeight: 600, textTransform: 'capitalize' }}>{(item?.list?.length ?? 0) > 0 ? item?.customerName?.toLowerCase() : maskInfo(item?.portfolioName || '')?.toLowerCase()}</Typography>
                                                                    <Box onClick={(e) => e.stopPropagation()}>
                                                                        <IconCustomeDropDown data={item} filterValue={filterValue as any} isToggle={true} />
                                                                    </Box>
                                                                </Box>
                                                                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px', mt: 1 }}>
                                                                    <Box>
                                                                        <Typography sx={{ color: palette.text.secondary, fontSize: 11, textTransform: 'uppercase' }}>% of book</Typography>
                                                                        <Typography sx={{ color: palette.text.primary, fontWeight: 500, fontSize: 10 }}>{item?.marketValue ? ((((item?.marketValue as number) / aumAmount) * 100) || 0)?.toFixed(2) : 0}</Typography>
                                                                    </Box>
                                                                    <Box>
                                                                        <Typography sx={{ color: palette.text.secondary, fontSize: 11, textTransform: 'uppercase' }}>invested value</Typography>
                                                                        <Typography sx={{ color: palette.text.primary, fontWeight: 500, fontSize: 10 }}>{item?.investedValue as number < 0 ? `- ${formatCurrency({ value: Math.abs(item?.investedValue ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: item?.investedValue ?? 0, locale, currencyCode })}`}</Typography>
                                                                    </Box>
                                                                    <Box>
                                                                        <Typography sx={{ color: palette.text.secondary, fontSize: 11, textTransform: 'uppercase' }}>market value</Typography>
                                                                        <Typography sx={{ color: palette.text.primary, fontWeight: 500, fontSize: 10 }}>{item?.marketValue as number < 0 ? `- ${formatCurrency({ value: Math.abs(item?.marketValue ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: (item?.marketValue ?? 0), locale, currencyCode })}`}</Typography>
                                                                    </Box>
                                                                    <Box>
                                                                        <Typography sx={{ color: palette.text.secondary, fontSize: 11, textTransform: 'uppercase' }}>unrealised return</Typography>
                                                                        <Typography sx={{ color: (item?.unrealised as number) < 0 ? palette.error[500] : palette.success[500], fontWeight: 500, fontSize: 10 }}>{item?.unrealised as number >= 0 ? '' : '-'}{formatCurrency({ value: Math.abs(item?.unrealised as number), locale, currencyCode })}</Typography>
                                                                    </Box>
                                                                    <Box>
                                                                        <Typography sx={{ color: palette.text.secondary, fontSize: 11, textTransform: 'uppercase' }}>cash available</Typography>
                                                                        <Typography sx={{ color: palette.text.primary, fontWeight: 500, fontSize: 10 }}>{item?.cash as number < 0 ? `- ${formatCurrency({ value: Math.abs(item?.cash ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: item?.cash ?? 0, locale, currencyCode })}`}</Typography>
                                                                    </Box>
                                                                    <Box>
                                                                        <Typography sx={{ color: palette.text.secondary, fontSize: 11, textTransform: 'uppercase' }}>Absolute Return %</Typography>
                                                                        <Typography sx={{ color: (item?.irr as number) < 0 ? palette.error[500] : palette.success[500], fontWeight: 500, fontSize: 10 }}>{item?.irr?.toFixed(2)}%</Typography>
                                                                    </Box>
                                                                </Box>
                                                            </Box>
                                                        </Paper>
                                                    ))}
                                                </Box>
                                            )}
                                        </Box>
                                    </Paper>
                                ))}
                            {!isLoading && (_.orderBy(tableData, [sorting.name], [sorting.order ? sorting.order : 'desc']).
                                filter((row) => filterValue === 1 ? row.customerName?.toLowerCase().includes(searchInput?.toLowerCase()) : row.familyName?.toLowerCase().includes(searchInput?.toLowerCase())).
                                sort((a, b) => sorting.order === 'desc' ? (a[sorting.name] - b[sorting.name]) : (b[sorting.name] - a[sorting.name])).
                                slice((currentPage) * rowOption, ((currentPage) * rowOption) + rowOption)).length === 0 ? (
                                <Typography sx={{ textAlign: 'center' }} variant='h2' color={'text.primary'}>{NO_DATA_AVAILABLE}</Typography>
                            ) : null}
                            <TablePagination
                                rowsPerPageOptions={rowArray}
                                component="div"
                                count={_.orderBy(tableData, [sorting.name], [sorting.order ? sorting.order : 'desc']).filter((row) => filterValue === 1 ? row.customerName?.toLowerCase().includes(searchInput?.toLowerCase()) : row.familyName?.toLowerCase().includes(searchInput?.toLowerCase())).length}
                                rowsPerPage={rowOption}
                                page={currentPage}
                                labelRowsPerPage={"Rows per page:"}
                                onPageChange={handlePageChange}
                                onRowsPerPageChange={(e) => handleRow(e.target.value)}
                                sx={{
                                    display: { xs: 'block', sm: 'none' },
                                    color: palette.text.primary[500]
                                }}
                            />
                        </>
                    )}
                </Box>

                <TableContainer style={{ padding: '15px 15px 25px 15px' }} sx={{ display: { xs: 'none', sm: 'block' }, '& .investor-name-link:focus-visible': { outline: `2px solid ${palette.primary[500]}`, outlineOffset: '2px', borderRadius: '4px' }  }}>
                    <Table aria-label="collapsible table" style={{ tableLayout: "auto" }}>
                        <TableHead sx={{ display: "table-header-group" }}>
                            <TableRow >
                                <TableCell style={{ ...style, paddingLeft: '15px' }}>
                                    <TableSortLabel active={(filterValue === 1 ? 'customerName' : 'familyName') === sorting.name}
                                        direction={sorting.order}
                                        onClick={() => handleSorting(filterValue === 1 ? 'customerName' : 'familyName')}>Name</TableSortLabel>
                                </TableCell>
                                {/* {filterValue === 1 ?
                                    <TableCell align='center' style={{ ...style }}>
                                        <TableSortLabel active={'accountType' === sorting.name}
                                            direction={sorting.order}
                                            onClick={() => handleSorting('accountType')}>Account Type</TableSortLabel>
                                    </TableCell> : null
                                } */}
                                <TableCell align='center' style={{ ...style }}>
                                    <TableSortLabel active={'relationManagerName' === sorting.name}
                                        direction={sorting.order}
                                        onClick={() => handleSorting('relationManagerName')}>RM Name</TableSortLabel>
                                </TableCell>
                                {filterValue === 2 && (
                                    <TableCell align='center' style={{ ...style }}>
                                        <TableSortLabel
                                            active={'familyId' === sorting.name}
                                            direction={sorting.order}
                                            onClick={() => handleSorting('familyId')}
                                        >Family ID</TableSortLabel>
                                    </TableCell>
                                )}
                                <TableCell align='center' style={{ ...style }} >
                                    <TableSortLabel
                                        active={'clientCode' === sorting.name}
                                        direction={sorting.order}
                                        onClick={() => handleSorting('clientCode')}>Client Code</TableSortLabel>
                                </TableCell>
                                <TableCell align='center' style={{ ...style }}>
                                    <TableSortLabel active={'marketValue' === sorting.name}
                                        direction={sorting.order}
                                        onClick={() => handleSorting('marketValue')}>% of book</TableSortLabel>
                                </TableCell>
                                <TableCell align='center' style={{ ...style }}>
                                    <TableSortLabel active={'investedValue' === sorting.name}
                                        direction={sorting.order}
                                        onClick={() => handleSorting('investedValue')}>invested value</TableSortLabel>
                                </TableCell>
                                <TableCell align='center' style={{ ...style }} >
                                    <TableSortLabel active={'marketValue' === sorting.name}
                                        direction={sorting.order}
                                        onClick={() => handleSorting('marketValue')}>market value</TableSortLabel>
                                </TableCell>
                                <TableCell align='center' style={{ ...style }} >
                                    <TableSortLabel active={'unrealised' === sorting.name}
                                        direction={sorting.order}
                                        onClick={() => handleSorting('unrealised')}>unrealised <br /> return</TableSortLabel>
                                </TableCell>
                                {/* <TableCell align='center' style={{ ...style }} >
                                    <TableSortLabel active={'cash' === sorting.name}
                                        direction={sorting.order}
                                        onClick={() => handleSorting('cash')}>cash Available</TableSortLabel>
                                </TableCell> */}
                                <TableCell align='center' style={{ ...style }} >
                                    <TableSortLabel active={'irr' === sorting.name}
                                        direction={sorting.order}
                                        onClick={() => handleSorting('irr')}>Absolute <br /> Return %</TableSortLabel>
                                </TableCell>
                                <TableCell align='center' style={{ ...style }} >actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {isLoading ? <TableLoader row={5} column={8} /> : null}
                            {!isLoading && error ?
                                <TableRow>
                                    <TableCell colSpan={8}>
                                        <Typography sx={{ textAlign: 'center' }} variant='h2' color={'text.primary'}>{NO_DATA_AVAILABLE}</Typography>
                                    </TableCell>
                                </TableRow> : null
                            }
                            {!error && !isLoading ?
                                <>
                                    {(_.orderBy(tableData, [sorting.name], [sorting.order ? sorting.order : 'desc']).filter((row) => filterValue === 1 ? row.customerName?.toLowerCase().includes(searchInput?.toLowerCase()) : row.familyName?.toLowerCase().includes(searchInput?.toLowerCase())).sort((a, b) => sorting.order === 'desc' ? (a[sorting.name] - b[sorting.name]) : (b[sorting.name] - a[sorting.name])).slice((currentPage) * rowOption, ((currentPage) * rowOption) + rowOption)).map((row, i) => (
                                        <Row key={i + row?.portfolioName} row={row} border={false} child={false} right={false} filterValue={filterValue as any} aumAmount={aumAmount} />
                                    ))}
                                    {!isLoading && (_.orderBy(tableData, [sorting.name], [sorting.order ? sorting.order : 'desc']).filter((row) => filterValue === 1 ? row.customerName?.toLowerCase().includes(searchInput?.toLowerCase()) : row.familyName?.toLowerCase().includes(searchInput?.toLowerCase())).sort((a, b) => sorting.order === 'desc' ? (a[sorting.name] - b[sorting.name]) : (b[sorting.name] - a[sorting.name])).slice((currentPage) * rowOption, ((currentPage) * rowOption) + rowOption)).length === 0 ?
                                        <TableRow>
                                            <TableCell colSpan={8}>
                                                <Typography sx={{ textAlign: 'center' }} variant='h2' color={'text.primary'}>{NO_DATA_AVAILABLE}</Typography>
                                            </TableCell>
                                        </TableRow> : null
                                    }
                                </> : null
                            }
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={rowArray}
                        component="div"
                        count={_.orderBy(tableData, [sorting.name], [sorting.order ? sorting.order : 'desc']).filter((row) => filterValue === 1 ? row.customerName?.toLowerCase().includes(searchInput?.toLowerCase()) : row.familyName?.toLowerCase().includes(searchInput?.toLowerCase())).length}
                        rowsPerPage={rowOption}
                        page={currentPage}
                        labelRowsPerPage={"Rows per page:"}
                        onPageChange={handlePageChange}
                        onRowsPerPageChange={(e) => handleRow(e.target.value)}
                        sx={{
                            color: palette.text.primary[500]
                        }} />
                </TableContainer>
            </Box >
        </>
    )
}



function Row(props: { row: RowProps | undefined, border?: boolean, child: boolean, right?: boolean, clickable?: boolean | undefined, filterValue: number, aumAmount: number }) {
    const { row, border, child, right, clickable, filterValue, aumAmount } = props;
    const [open, setOpen] = React.useState(false);
    const { palette } = useTheme()
    const history = useHistory()
    const dispatch = useDispatch()

    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    const style = { color: palette.text.primary, fontWeight: 500, padding: 0 }
    const { navigateWithStack } = useRoleStack();

    const handleClick = () => {

        dispatch(setClientCode((row?.clientCode || "") as string))
        dispatch(storeSelectedPortfolio({ label: '', value: '' }))

        if (filterValue === 1) {
            navigateWithStack(`/investor-profile/${row?.customerName}`, {
                clientCode: (row?.clientCode || "") as string,
                portfoiloId: row?.portfoiloId || "",
                accountFilter: filterValue
            })
        } else if (filterValue === 2) {
            if (!child) {
                history.push(`/family/family-profile/${(maskInfo(row?.familyName || ""))}`, {
                    familyName: (row?.familyName || "") as string,
                    accountFilter: filterValue,
                    familyId: row?.familyId
                })
            } else {
                history.push(`/investor-profile/${row?.customerName}`, {
                    clientCode: (row?.clientCode || "") as string,
                    portfoiloId: row?.portfoiloId || "",
                    accountFilter: filterValue
                })
            }
        }
        // }
    }

    return (
        <>
            <TableRow style={{
                borderLeft: (child || open) ? `3px solid ${palette.primary[500]}` : '3px solid transparent',
                padding: border ? '10px 0px' : '0px',
                margin: border ? '10px 0px' : '0px',
            }}>
                {/* #23 */}
                <TableCell
                    onClick={(e) => (filterValue === 2 && !child && row?.familyName?.toLowerCase() === 'not applicable') ? null : handleClick()}
                    sx={{
                        opacity: (filterValue === 2 && !child && row?.familyName?.toLowerCase() === 'not applicable') ? 0.5 : 1,
                    }}
                    component="th" scope="row" style={{
                        padding: right ? '0px 30px' : '0px 8px',
                        color: palette.primary[500],
                        fontWeight: 500,
                        textTransform: 'capitalize',
                        cursor: 'pointer',
                    }}
                >
                    <Box display="flex" alignItems="center" gap={1}>
                        {row?.child ? (
                            <IconButton
                                aria-label="expand row"
                                size="small"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setOpen(!open);
                                }}
                            >
                                {!open ? <SideDropDownIcon /> : <DropDownIcons />}
                            </IconButton>
                        ) : (
                            <IconButton
                                aria-hidden="true"
                                size="small"
                                style={{ backgroundColor: 'transparent', visibility: 'hidden' }}
                                disableRipple
                            >
                                <SideDropDownIcon />
                            </IconButton>
                        )}

                        <span
                            tabIndex={0}
                            role="button"
                            aria-label={
                                child
                                    ? (row?.list?.length ?? 0) > 0
                                        ? `View investor ${row?.customerName ?? ''}`
                                        : `View portfolio ${row?.portfolioName ?? ''}`
                                    : filterValue === 1
                                        ? `View investor ${row?.customerName ?? ''}`
                                        : `View family ${row?.familyName ?? ''}`
                            }
                            onClick={(e) => {
                                e.stopPropagation();
                                if (!(filterValue === 2 && !child && row?.familyName?.toLowerCase() === 'not applicable')) {
                                    handleClick();
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if (!(filterValue === 2 && !child && row?.familyName?.toLowerCase() === 'not applicable')) {
                                        handleClick();
                                    }
                                }
                            }}
                            style={{
                                outline: 'none',
                                cursor: 'pointer',
                            }}
                            className="investor-name-link"
                        >
                            {child
                                ? (row?.list?.length ?? 0) > 0
                                    ? row?.customerName?.toLowerCase()
                                    : maskInfo(row?.portfolioName || '')?.toLowerCase()
                                : filterValue === 1
                                    ? row?.customerName?.toLowerCase()
                                    : row?.familyName === 'Not Applicable'
                                        ? row?.customerName?.toLowerCase()
                                        : maskInfo((row?.familyName || '')?.toLowerCase())}
                            {`${(row?.list?.length ?? 0) > 0 ? ` (${row?.list?.length})` : ''}`}
                        </span>
                    </Box>
                </TableCell>

                {/* {filterValue === 1 ?
                    <TableCell align="center" style={{ ...style }}>
                        {row?.child ? row?.accountType ?? "-" : "-"}
                    </TableCell> : null
                } */}
                {/* Investor Type Row End */}
                <TableCell align="center" style={{ ...style }}>
                    {filterValue === 2 ? (row?.relationManagerName ? row?.relationManagerName : (row?.list?.[0]?.relationManagerName ? row?.list?.[0]?.relationManagerName : "-")) : (child ? "-" : row?.relationManagerName ? row?.relationManagerName : "-")}
                </TableCell>
                {filterValue === 2 && (
                    <TableCell align="center" style={{ ...style, paddingLeft: '10px' }}>
                        {child ? "-" : (row?.familyId ? row?.familyId : "-")}
                    </TableCell>
                )}
                <TableCell align="center" style={{ ...style }}>
                    {filterValue === 2 ? (child ? (row?.clientCode ? row?.clientCode : "-") : "-") : (row?.clientCode ? row?.clientCode : "-")}
                </TableCell>

                <TableCell align="center" style={{ ...style }}>
                    {row?.marketValue ? ((((row?.marketValue as number) / aumAmount) * 100) || 0)?.toFixed(2) : 0}
                </TableCell>
                <TableCell align="center" style={{ ...style }}>
                    {row?.investedValue as number < 0 ? `- ${formatCurrency({ value: Math.abs(row?.investedValue ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: row?.investedValue ?? 0, locale, currencyCode })}`}
                </TableCell>
                <TableCell align="center" style={{ ...style }}>
                    {row?.marketValue as number < 0 ? `- ${formatCurrency({ value: Math.abs(row?.marketValue ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: (row?.marketValue ?? 0), locale, currencyCode })}`}
                </TableCell>
                <TableCell align="center" style={{ ...style, color: (row?.unrealised as number) < 0 ? palette.error[500] : palette.success[500] }}>{row?.unrealised as number >= 0 ? '' : '-'}{formatCurrency({ value: Math.abs(row?.unrealised as number), locale, currencyCode })}
                </TableCell>
                {/* <TableCell align="center" style={{ ...style }}>
                    {row?.cash as number < 0 ? `- ${formatCurrency({ value: Math.abs(row?.cash ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: row?.cash ?? 0, locale, currencyCode })}`}
                </TableCell> */}
                <TableCell align="center" style={{ ...style, color: (row?.irr as number) < 0 ? palette.error[500] : palette.success[500] }}>{row?.irr?.toFixed(2)}%</TableCell>
                <TableCell align="center" style={{ ...style }}>
                    <IconCustomeDropDown data={row} filterValue={filterValue} isToggle={child} />
                </TableCell>
            </TableRow >
            {(row?.child && open) &&
                row?.list?.map((item, i) => (
                    <Row key={i} row={item} border={false} child={true} right={true} filterValue={filterValue} aumAmount={aumAmount} />
                ))
            }
        </>
    );
}


function TableLoader(props: { row: number, column: number }) {
    const { row = 5, column = 8 } = props
    return (
        <>
            {[...Array(row)].map((_, index) => (
                <TableRow key={index} sx={{ '& > *': { borderBottom: 'unset' } }} style={{
                    borderLeft: 'none',
                    padding: '0px',
                    margin: '0px',
                    transitionTimingFunction: 'ease-in'
                }}>

                    {[...Array(column)].map((_, index) => (

                        <TableCell
                            key={index}
                            component="th"
                            scope="row"
                            style={{
                                padding: '0px 8px',
                                color: 'transparent',
                                fontWeight: 500,
                                textTransform: 'capitalize',
                                cursor: 'pointer'
                            }}
                        >
                            <Skeleton
                                variant="text"
                                animation="wave"
                                sx={{
                                    padding: '10px 100px',
                                    borderRadius: "7px"
                                }}
                            />
                        </TableCell>
                    ))}

                </TableRow>
            ))}
        </>
    )
}